module.exports = __webpack_public_path__ + "img/image.d44c752d.png";